import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import "./Layout.scss";
import { SIDEBAR_WIDTH } from "../constants";
import { useLazyRcvdAllNotificatiosQuery } from "../services/notifications";
import { STORAGE_KEYS, getFromStorage, removeFromStorage } from "../helpers";
import { setCredentials } from "../reducers/authSlice";
import { useAppDispatch, useAppSelector } from "../hooks/store";
import { useLazyGetUserQuery, usePostLogoutMutation } from "../services/auth";
import useAuth from "../hooks/useAuth";
import LogoutModal from "../components/LogoutModal";
// import { useLazyDeleteNotificationQuery, useLazyGetReviewerNotificationsQuery } from "../services/notifications";
import { Padding } from "@mui/icons-material";
import {
  getRecentNotificationCount,
  setNotificationCount,
  setRequestCount,
} from "../reducers/generalSlice";
import { socket } from "../utils/socket";
import { store } from "../app/store";

interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [getUser] = useLazyGetUserQuery();

  const [openLogout, setOpenLogout] = useState<boolean>(false);

  const user = useAuth();

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    fetchData();
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  // const navigate = useNavigate();
  const [getAllNotifications] = useLazyRcvdAllNotificatiosQuery();
  const recentNotificationCount = useAppSelector(getRecentNotificationCount);

  const [rows, setRows] = useState<any>([]);

  const fetchData = async () => {
    try {
      const response = await getAllNotifications({
        page: 1,
        search: "",
        limit: 5,
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response?.data[0]?.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogout = async () => {
    try {
      navigate("/");
      removeFromStorage(STORAGE_KEYS.token);
      removeFromStorage(STORAGE_KEYS.tempToken);
      dispatch(
        setCredentials({
          user: null,
          token: null,
        })
      );
    } catch (error: any) {
      // errorToast(error?.data?.message || "");
    }
  };

  const getUserDetails = async () => {
    const token = await getFromStorage(STORAGE_KEYS.token);

    if (token) {
      try {
        const result = await getUser({}).unwrap();
        if (result?.statusCode === 200 && token) {
          dispatch(
            setCredentials({
              user: result?.data,
              token: token,
            })
          );
          dispatch(
            setRequestCount({
              agents: result?.data?.data?.agent,
              company: result?.data?.data?.company,
              companyRequests: result?.data?.data?.companyRequests,
              propertyRequest: result?.data?.data?.propertyRequests,
              paymentRequestCount:result?.data?.data?.paymentRequestNotifications
            })
          );
          dispatch(
            setNotificationCount({
              newNotificationCount: result?.data?.data?.totalNotifications,
              newUsers: result?.data?.data?.userNotifications,
              newPropertyListing: result?.data?.data?.propertyListing,
              newPropertyReports: result?.data?.data?.propertyReports,
              newListingActionTracker: result?.data?.data?.listingActionTracker,
              newEnquriesCount: result?.data?.data?.enquiriesNotifications,
              newFeedbackCount: result?.data?.data?.feedbackNotifications
            })
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    const userData = getFromStorage(STORAGE_KEYS.credentials);
    if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: JSON.parse(`${userData}`),
        })
      );
      getUserDetails();
    }
  }, []);

  const handleNotificationClick = (item: any) => {
    handleClose1();
    if (item?.pushType === 8) {
      navigate("/manage-users");
    } else if (item?.pushType === 9) {
      navigate("/manage-agents");
    } else if (item?.pushType === 10) {
      navigate("/manage-company");
    } else if (item?.pushType === 28) {
      navigate("/manage-company-requests");
    } else if (item?.pushType === 24 || item?.pushType === 25) {
      navigate("/manage-property-requests");
    } else if (item?.pushType === 30) {
      navigate("/manage-property-reports");
    } else if (item?.pushType === 31) {
      navigate("/listing-action-tracker");
    } else if (item?.pushType === 7) {
      navigate("/property-listing");
    } else if (item?.pushType === 32) {
      navigate("/manage-enqueries");
    } else if (item?.pushType === 33) {
      navigate("/manage-feedbacks");
    } else {
      navigate("/recieved-notifications");
    }
  };

  const newNotificationSocket = async () => {
    if (socket) {
      socket?.on("newNotificationReceived", async (response: any) => {
        const state = store.getState();
        const newNotificationCount = state.general.newNotificationCount;
        const newUsers = state.general.newUsers;
        const newPropertyReports = state.general.newPropertyReports;
        const newListingActionTracker = state.general.newListingActionTracker;
        const newPropertyListing = state.general.newPropertyListing;
        const newEnquries = state.general.newEnquriesCount;
        const newFeedback = state.general.newFeedbackCount;

        console.log(response, "responseresponseresponse");

        if (response?.statusCode === 200) {
          store.dispatch(
            setNotificationCount({
              newNotificationCount: newNotificationCount + 1,
              newUsers:
                response?.data?.pushType === 8 ? newUsers + 1 : newUsers,
              newPropertyListing:
                response?.data?.pushType === 7
                  ? newPropertyListing + 1
                  : newPropertyListing,
              newPropertyReports:
                response?.data?.pushType === 30
                  ? newPropertyReports + 1
                  : newPropertyReports,
              newListingActionTracker:
                response?.data?.pushType === 31
                  ? newListingActionTracker + 1
                  : newListingActionTracker,
              newEnquriesCount: response?.data?.pushType === 32 ? newEnquries + 1 : newEnquries,
              newFeedbackCount: response?.data?.pushType === 33 ? newFeedback + 1 : newFeedback,
            })
          );
        }
      });
    }
  };

  useEffect(() => {
    newNotificationSocket();
    return () => {
      if (socket) {
        socket?.off("newNotificationReceived");
      }
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  return (
    <Box className="top_bar">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <IconButton
            color="inherit"
            aria-label="open sidebar"
            edge="start"
            onClick={handleSidebarToggle}
            style={{ backgroundColor: "#72cedd" }}
            sx={{
              display: { xs: "flex", lg: "none" },
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box className="topbar_rt">
            <Box>
              <IconButton
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <NotificationsActiveIcon />
                {recentNotificationCount ? (
                  <span className="notification_badge">
                    {recentNotificationCount}
                  </span>
                ) : null}
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 10,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  <Button
                    className="btn btn_primary sm"
                    onClick={() => {
                      handleClose1();
                      navigate("/recieved-notifications");
                    }}
                  >
                    See All
                  </Button>
                </Box>
                <ul className="noti_list">
                  {rows?.slice(0, 3)?.length > 0 ? (
                    <>
                      {rows
                        ?.slice(0, 3)
                        ?.map((notification: any, index: number) => (
                          <li
                            key={index}
                            onClick={() =>
                              handleNotificationClick(notification)
                            }
                          >
                            <div className="noti_info">
                              <Typography component="h3">
                                {notification.title}
                              </Typography>
                              <Typography component="p">
                                {notification.message}
                              </Typography>
                            </div>
                          </li>
                        ))}
                      {/* <Button
                      className="btn btn_primary sm"
                      onClick={() => navigate("/recieved-notifications")}
                      >
                        See All
                      </Button> */}
                    </>
                  ) : (
                    <Typography style={{ padding: 10 }}>
                      No notification received
                    </Typography>
                  )}
                </ul>
              </Menu>
            </Box>
            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img
                  src={
                    user?.image
                      ? user?.image
                      : "/static/images/user_placeholder.png"
                  }
                  alt=""
                />
                <span>{(user?.name || "Admin") + " "}</span>
                <KeyboardArrowDownIcon />
              </IconButton>
              <Menu
                className="userDropdown_menu"
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 10,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/profile")}
                >
                  <IconButton className="drpdwn_icns">
                    <PersonIcon />
                  </IconButton>
                  My Profile
                </MenuItem>
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/changepassword")}
                >
                  <IconButton className="drpdwn_icns">
                    <LockResetIcon />
                  </IconButton>
                  Change Password
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => setOpenLogout(true)}
                >
                  <IconButton className="drpdwn_icns">
                    <LogoutIcon />
                  </IconButton>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <LogoutModal
        openLogout={openLogout}
        setOpenLogout={setOpenLogout}
        handleLogout={handleLogout}
      />
    </Box>
  );
}

export default Topbar;
